import { nothing } from 'lit';

export function paginationTemplate() {
  return nothing;
}
